export default "__VITE_ASSET__D5HrZcy8__"